module.exports = __webpack_public_path__ + "img/1_ileum.cf4de5de.png";